import { decodeJWT } from '@/shared/lib/auth';
import { buildSelector } from '@/shared/lib/store';

export const [useSessionFeatures] = buildSelector((state): string[] => {
    const { accessToken } = state.session;

    if (!accessToken) {
        return [];
    }

    const payload = decodeJWT(accessToken);
    const features = payload?.['features'];

    return Array.isArray(features) ? features : [];
});
